/*global mmgs_checkout_params */
var mmgs_account_form;

jQuery(document).ready(function ($) {
	// ensure mmgs_checkout_params exists
	if (typeof mmgs_checkout_params === 'undefined') {
		return false;
	}

	var checkout_actions = $.parseJSON(mmgs_checkout_params.checkout_actions);

	/**
	 * @type {{init: init, show_billing_info: show_billing_info}}
	 */
	var mmgs_checkout_form = {
		/**
		 * Current selected currency (to store selected currency from the 'suggested currency' pop up)
		 * @type {string}
		 */
		current_selected_currency: '',
		init: function () {
			// $('#country').change(this.update_states);

			/* Show billing info if the checkout action is change payment method */
			if ($('#user_current_billing_info').length) {
				this.show_billing_info();
			} else {
				$('#my-account-button-container').append(
					'<a href="' +
					$('#account-page-url').val() +
					'" class="btn-back"><span class="icon-long-arrow-left"></span>Back to My Account</a>'
				);
			}

			if ($('#preview_subscription_box').length) {
				this.preview_subscription($('input[name="membership_plan"]').val(), '');
			}

			/* Hide or show taxes sections */
			mmgs_checkout_form.detect_eu_countries($('#country').val());

			$(document).on(
				'submit',
				'#update_billing_info_form, #checkout_with_recurly',
				function (e) {
					e.preventDefault();

					window.mmgs_recurly_form.submit_recurly_form($(this));
				}
			);

			$(document).on('change', '#mmgs_currency_select', this.update_currency);

			/* Currency switcher pop-up */
			if ($('.checkout-currency-modal-link').length > 0) {
				$('.checkout-currency-modal-link').magnificPopup({
					type: 'inline',
					preloader: true,
					modal: true,
				});

				$('.checkout-currency-modal-link').click();
			}

			/* 'suggested currency' modal close, continue */
			$(document).on(
				'click',
				'.checkout-currency-modal-dismiss',
				this.checkout_currency_modal_dismiss_handler
			);
			$(document).on(
				'click',
				'#checkout_currency_modal_continue',
				this.checkout_currency_modal_continue_handler
			);

			/* Suggested currency select change */
			$(document).on(
				'change',
				'#mmgs_suggested_currency_select',
				this.mmgs_suggested_currency_select_handler
			);
		},
		detect_eu_countries: function (country) {
			var eu_section = $('.eu-section');
			var tax_info = ' + tax';
			var radio_button_elm = $('.tax-info');

			var eu_countries = [
				'AT',
				'BE',
				'BG',
				'CY',
				'CZ',
				'DK',
				'EE',
				'ES',
				'FI',
				'FR',
				'DE',
				'GB',
				'GR',
				'HU',
				'IE',
				'IT',
				'LV',
				'LT',
				'LU',
				'MT',
				'NL',
				'PL',
				'PT',
				'RO',
				'SE',
				'SI',
				'SK',
				'HR',
			];

			if (~eu_countries.indexOf(country)) {
				eu_section.show();

				// Add tax information from radio button.
				radio_button_elm.each(function () {
					$(this)
						.find('.tax-text')
						.removeClass('hidden');
					// var original_text = $(this).html();
					// if (!original_text.includes(tax_info)) {
					// 	$(this).html(original_text.concat(tax_info));
					// }
				});
			} else {
				eu_section.hide();

				// Remove tax information from radio button.
				radio_button_elm.each(function () {
					$(this)
						.find('.tax-text')
						.addClass('hidden');
					// var original_text = $(this).html();
					// $(this).html(original_text.replace(tax_info, ''));
				});
			}
		},
		// update_states: function() {
		// 	/* Update 'State' field on 'Country' change */
		// 	var $this = $('#country');
		// 	$('#state')
		// 		.parents('.cmn-col')
		// 		.append("<div class='block-overlay'></div>");
		// 	var country = $this.val();
		// 	var parent = $this.closest('.cmn-col');

		// 	parent.append("<div class='block-overlay'></div>");

		// 	/* Hide or show taxes sections */
		// 	mmgs_checkout_form.detect_eu_countries(country);

		// 	// todo -frontend: show something imitating the loading while request is in progress
		// 	$.ajax({
		// 		type: 'POST',
		// 		url: mmgs_checkout_params.ajax_url,
		// 		data: {
		// 			action: 'update_states_for_country',
		// 			country: country,
		// 		},
		// 		success: function(responce_data) {
		// 			$('.block-overlay').remove();
		// 			$('#state').replaceWith(responce_data.data.states_field);

		// 			// parent.find('.mmgs-state').addClass('field-validated');
		// 			// $('#state').blur(function() {
		// 			// 	$(this)
		// 			// 		.closest('.mmgs-state')
		// 			// 		.removeClass('field-validated');
		// 			// });
		// 		},
		// 		error: function(jqXHR, textStatus, errorThrown) {
		// 			$('.block-overlay').remove();
		// 		},
		// 	});
		// },
		show_billing_info: function () {
			$('.checkout-wrap').addClass('page-is-loading');
			$('#checkout_with_recurly').prop('id', 'update_billing_info_form');

			var data = { action: 'fetch_current_billing_info' };
			if (
				typeof getQueryVariable === 'function' &&
				$.inArray(getQueryVariable('rc_action'), [
					checkout_actions.switch_subscription,
					checkout_actions.resubscribe,
					checkout_actions.change_subscription,
				]) > -1
			) {
				data.fetch_subscription_info = 'yes';
				data.new_plan = getQueryVariable('switch_to_plan_code');
			}

			if (
				typeof getQueryVariable === 'function' &&
				checkout_actions.change_payment_method == getQueryVariable('rc_action')
			) {
				$('.checkout-title').text('Update Billing Information');
				$('.checkout-wrap').addClass('update-billing-page');
			} else if (
				typeof getQueryVariable === 'function' &&
				checkout_actions.switch_subscription == getQueryVariable('rc_action')
			) {
				$('.checkout-title').text(
					"This is exciting! You're about to become a vip yearly member"
				);
				$('.checkout-wrap').addClass('checkout-col-page upgrade-page');
			} else if (
				typeof getQueryVariable === 'function' &&
				checkout_actions.change_subscription == getQueryVariable('rc_action')
			) {
				$('.checkout-wrap').addClass('checkout-col-page upgrade-page');
			}
			else if (
				typeof getQueryVariable === 'function' &&
				checkout_actions.resubscribe == getQueryVariable('rc_action')
			) {
				$('.checkout-title').text(
					'Congratulations on becoming a vip member again'
				);
				$('.checkout-wrap').addClass('checkout-col-page resubscribe-page');
			}

			/* Change back button href */
			$('#my-account-button-container').append(
				'<a href="' +
				$('#account-page-url').val() +
				'" class="btn-back"><span class="icon-long-arrow-left"></span>Back to My Account</a>'
			);

			/* Show 'go to dashboard' link in header */
			$('.header-top li.menu-dashboard-link').show();

			$.ajax({
				type: 'POST',
				url: mmgs_checkout_params.ajax_url,
				data: data,
				success: function (responce_data) {
					if (true === responce_data.success) {
						/* Change payment method */
						if (
							typeof getQueryVariable === 'function' &&
							checkout_actions.change_payment_method ==
							getQueryVariable('rc_action')
						) {
							/* Credit Card Info */
							if (responce_data.data.first_six) {
								/*recurly.configure({
									publicKey: mmgs_recurly_params.recurly_public_key,
									fraud: {
										kount: {
											dataCollector: true,
											form: $('#checkout_with_recurly', true),
										}
									},
									fields: {
										card: {
											style: {
												placeholder: {
													content: {
														number:
															responce_data.data.first_six +
															'******' +
															responce_data.data.last_four,
													},
												},
											},
										},
									},
								});*/

								/* Select 'Credit Card' payment method */
								$('#selected_payment_method_cc').prop('checked', true);

								/* Store current payment method */
								$('input[name="previously_saved_payment_method"]').val(
									'credit_card'
								);

								$('.mmgs-hide-for-paypal').show();
							} else {
								/* PayPal case */
								$('.remove-for-paypal').hide();
								$('#mmgs_notify_paypal_connected').show();

								$('.mmgs-hide-for-paypal').hide();

								/* Select 'PayPal' payment method */
								$('#selected_payment_method_paypal').prop('checked', true);

								/* Store current payment method */
								$('input[name="previously_saved_payment_method"]').val(
									'paypal'
								);
							}
						} else if (
							$('.upgrade-request-page').length > 0 ||
							(typeof getQueryVariable === 'function' &&
								$.inArray(getQueryVariable('rc_action'), [
									checkout_actions.switch_subscription,
									checkout_actions.resubscribe,
									checkout_actions.change_subscription,
								]) > -1)
						) {
							var $container = $('#mmgs_recurly_payment_method_info');
							var html = '';

							if (responce_data.data.first_six) {
								/* Payment method credit card */
								html +=
									'<div class="cmn-pad-row">' +
									'<label class="cmn-pad-label">First Name</label>' +
									'<div class="cmn-pad-value">' +
									responce_data.data.first_name +
									'</div>' +
									'</div>' +
									'<div class="cmn-pad-row">' +
									'<label class="cmn-pad-label">Last Name</label>' +
									'<div class="cmn-pad-value">' +
									responce_data.data.last_name +
									'</div>' +
									'</div>' +
									'<div class="cmn-pad-row">' +
									'<label class="cmn-pad-label">Country</label>' +
									'<div class="cmn-pad-value">' +
									responce_data.data.country +
									'</div>' +
									'</div>' +
									'<div class="cmn-pad-row">' +
									'<label class="cmn-pad-label">Connected Credit Card</label>' +
									'<div class="cmn-pad-value text-lowercase">' +
									responce_data.data.card_type +
									' ' +
									responce_data.data.first_six +
									'******' +
									responce_data.data.last_four +
									'</div>' +
									'</div>' +
									'<div class="cmn-pad-row">' +
									'<label class="cmn-pad-label">Expiration</label>' +
									'<div class="cmn-pad-value">' +
									responce_data.data.month +
									'/' +
									responce_data.data.year +
									'</div>' +
									'</div>';
							} else {
								/* Payment method PayPal */
								html +=
									'<div class="cmn-pad-row">' +
									'<p>Connected PayPal account</p>' +
									'<div class="cmn-pad-item">First Name: ' +
									responce_data.data.first_name +
									'</div>' +
									'<div class="cmn-pad-item">Last Name: ' +
									responce_data.data.last_name +
									'</div>' +
									'</div>';
							}

							$container.html(html);

							if (responce_data.data.current_period_ends_at) {
								var recurring_total_block = '';
								var current_plan_block = '';
								var next_renewal_field_label = 'NEXT RENEWAL';
								if (
									typeof getQueryVariable === 'function' &&
									$.inArray(getQueryVariable('rc_action'), [
										checkout_actions.switch_subscription,
										checkout_actions.change_subscription,
									]) > -1
								) {
									recurring_total_block =
										'<div class="cmn-pad-row text-bold eu-section"><label class="cmn-pad-label">Price</label><div class="cmn-pad-value">' +
										responce_data.data.currency_symbol +
										' ' +
										responce_data.data.unit_amount +
										' ' +
										responce_data.data.currency +
										'</div></div>' +
										'<div class="cmn-pad-row text-bold eu-section"><label class="cmn-pad-label">Tax</label><div class="cmn-pad-value">' +
										responce_data.data.currency_symbol +
										' ' +
										responce_data.data.tax_in_cents +
										' ' +
										'<span style="font-size: 50%"> ' +
										responce_data.data.currency +
										'</span></div></div>' +
										'<div class="cmn-pad-row text-bold"><label class="cmn-pad-label">Recurring Total</label><div class="cmn-pad-value">' +
										responce_data.data.currency_symbol +
										' ' +
										responce_data.data.total +
										' ' +
										'<span style="font-size: 50%"> ' +
										responce_data.data.currency +
										'</span></div></div>';
									current_plan_block =
										'<div class="cmn-pad-row"><label class="cmn-pad-label">Plan Name</label><div class="cmn-pad-value"><span>' +
										responce_data.data.plan_title +
										'</span></div></div>';
								}

								if (
									getQueryVariable('rc_action') == checkout_actions.resubscribe
								) {
									$('#recuring-total-container')
										.find('span[data-recurly="currency_symbol"]')
										.html(responce_data.data.currency_symbol);
									$('#recuring-total-container')
										.find('span[data-recurly="subtotal_next"]')
										.html(responce_data.data.unit_amount);
									$('#recuring-total-container')
										.find('span[data-recurly="taxes_next"]')
										.html(responce_data.data.tax_in_cents);
									$('#recuring-total-container')
										.find('span[data-recurly="total_next"]')
										.html(responce_data.data.total);
								}

								$('#mmgs_free_trial_block').hide();
								$('#mmgs_cancel_info_block').hide();
								$('#user_current_billing_info').replaceWith(
									current_plan_block +
									'<div class="cmn-pad-row text-bold"><label class="cmn-pad-label">' +
									next_renewal_field_label +
									'</label><div class="cmn-pad-value"><span>' +
									responce_data.data.current_period_ends_at +
									'</span></div></div>' +
									recurring_total_block
								);

								/* Hide or show taxes sections */
								mmgs_checkout_form.detect_eu_countries($('#country').val());
							}
						}
					}

					$('.checkout-wrap').removeClass('page-is-loading');
				},
			});
		},
		preview_subscription: function (plan_name, coupon_code) {
			var data = {
				action: 'preview_subscription',
				new_plan: plan_name,
				coupon_code: coupon_code,
			};

			$.ajax({
				type: 'POST',
				url: mmgs_checkout_params.ajax_url,
				data: data,
				success: function (responce_data) {
					if (true === responce_data.success) {
						if ($('#preview_subscription_box').length) {
							$('.preview_currency_symbol').html(responce_data.data.currency_symbol);
							$('.preview_currency_code').html(responce_data.data.currency_code);
							$('.preview_regular_price').html(responce_data.data.regular_price);
							$('.preview_paid').html(responce_data.data.paid);
							$('.preview_credit').html(responce_data.data.credit);
							$('.preview_total').html(responce_data.data.total);
							$('.preview_subtotal').html(responce_data.data.subtotal);
							$('.preview_tax').html(responce_data.data.tax);
							$('.preview_next_renewal_date').html(responce_data.data.next_renewal_date);
							$('.preview_discount').html(responce_data.data.discount);

							if (responce_data.data.discount) {
								$('.discount-row').show();
							} else {
								$('.discount-row').hide();
							}

							if (responce_data.data.credit) {
								$('.credit-row').show();
							} else {
								$('.credit-row').hide();
							}
						}
					}
				},
			});
		},
		update_currency: function () {
			var selected_currency = '';
			if (this.current_selected_currency) {
				selected_currency = this.current_selected_currency;
			} else {
				selected_currency = $('#mmgs_currency_select').val();
			}

			/* Selected currency store separately as hidden input value */
			$('#mmgs_selected_currency').val(selected_currency);

			/* Reset to yearly in order details */
			$('#checkout-current-plan').val('mmg-annual');
			mmgs_account_form.update_active_plan();

			/* Trigger recurly to recalculate the price after currency change */
			if (typeof recurly !== 'undefined' && recurly.configured) {
				recurly.Pricing.Checkout().attach(
					$('form[name="checkout_with_recurly"]')
				);
			}

			mmgs_account_form.update_radiobutton_prices();
		},
		handle_selected_currency: function (selected_currency) {
			/* Save selected currency (suggested currency modal) */
			var data = {
				action: 'handle_selected_currency',
				currency: selected_currency,
			};

			$.ajax({
				type: 'POST',
				url: mmgs_recurly_params.ajax_url,
				data: data,
				success: function (responce_data) { },
				error: function (xhr, error) {
					$.inArray(mmgs_recurly_params.mmg_website_mode, ['dev', 'local']) >
						-1 &&
						console &&
						console.log(error);
				},
			});
		},
		checkout_currency_modal_dismiss_handler: function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		},
		checkout_currency_modal_continue_handler: function (e) {
			e.preventDefault();
			$.magnificPopup.close();

			mmgs_checkout_form.handle_selected_currency(
				$('#mmgs_suggested_currency_select').val()
			);
		},
		mmgs_suggested_currency_select_handler: function (e) {
			var selected_currency = $('#mmgs_suggested_currency_select').val();
			$('#mmgs_currency_select option[value="' + selected_currency + '"]').prop(
				'selected',
				true
			);
			$('#mmgs_selected_currency').val(selected_currency);

			this.current_selected_currency = selected_currency;

			mmgs_checkout_form.update_currency();
		},
	};

	/**
	 * @type {{init: init}}
	 */
	mmgs_account_form = {
		init: function () {
			/* Check if page is checkout with recurly or woocommerce checkout or audemar sign up */
			if (
				$('.checkout-with-recurly-page').length > 0 ||
				$('.checkout-wrap').length > 0 ||
				$('.sign-up-for-audemar-page').length > 0
			) {
				/* If checkout action is 'resubscribe', 'switch' or 'change payment' direct to checkout */
				var rc_actions = [
					checkout_actions.switch_subscription,
					checkout_actions.resubscribe,
					checkout_actions.change_payment_method,
					checkout_actions.change_subscription,
				];
				if (
					typeof getQueryVariable === 'function' &&
					$.inArray(getQueryVariable('rc_action'), rc_actions) > -1
				) {
					/* Store selected plan and trigger event */
					$(document.body).trigger('mmgs_checkout_recurly_init');
				}

				if ($('#checkout-current-plan').length > 0) {
					mmgs_account_form.update_active_plan();
				}
			}

			$(document).on('change', 'input[name="membership-plan"]', function () {
				var active_plan = $(this).val();
				$('#checkout-current-plan').val(active_plan);

				// Change form text depends on plan name (monthly/annual)
				$('.cmn-pad-help-txt').html(
					'* This is a recurring ' + active_plan + ' payment'
				);

				mmgs_account_form.update_active_plan();
			});
		},
		update_active_plan: function () {
			var current_plan = $('#checkout-current-plan').val();

			/* Store selected plan and trigger event on checkout */
			$('input[name="membership_plan"]').val(current_plan);
			$(document.body).trigger('mmgs_checkout_recurly_init');
		},
		update_radiobutton_prices: function () {
			var current_currency_code = $('#mmgs_selected_currency').val();

			$('.membership-plan-list')
				.find('li')
				.addClass('hidden');
			$('#monthly_' + current_currency_code)
				.parents('li')
				.removeClass('hidden');
			$('#yearly_' + current_currency_code)
				.parents('li')
				.removeClass('hidden');
			$('#yearly_30_' + current_currency_code)
				.parents('li')
				.removeClass('hidden');
			$('#monthly_6_' + current_currency_code)
				.parents('li')
				.removeClass('hidden');

			$('#yearly_30_' + current_currency_code).prop('checked', true);
			$('#yearly_' + current_currency_code).prop('checked', true);
		},
	};

	mmgs_checkout_form.init();
	mmgs_account_form.init();
});
